import '../css/5gLoading.css';
import React,{ useState,useImperativeHandle } from 'react';

const loading = React.forwardRef((props, ref) => {
    const [show, setShow] = useState(true);

    useImperativeHandle(ref, () => ({
        toggleShow() {
            setShow(!show);
        }
    }));

    return (
        <div className="loadingcover" id="loadingCover" ref={ref} style={{display: show?"block":"none"}}>
            <div className="loading__icon">
                <div className="loading__circle"></div>
            </div>
        </div>
    );
});

export default loading;